import { createMocks } from '@backbase/foundation-ang/data-http';
import { Provider } from '@angular/core';

/**
* Mocks provider for /payment-order-aux-service/v2/payment URL pattern
*/
export const PaymentsHttpServiceGetTransfintbanQueryMocksProvider: Provider = createMocks([{
        urlPattern: "/payment-order-aux-service/v2/payment",
        method: "POST",
        responses: [
                {
                    status: 200,
                    body: {
  "name" : "Consulta de impuestos de transacciones",
  "tag" : 1,
  "$ref" : "examples/body/paymentorderauxservice_response.json"
}
                },
                {
                    status: 200,
                    body: {
  "originatorAccount" : {
    "arrangementId" : "7341696714117907699630",
    "externalArrangementId" : "7341696714117907600630",
    "identification" : {
      "identification" : "8a48e08c60daa5940160dac699050088",
      "schemeName" : "BBAN"
    }
  },
  "paymentType" : "IN",
  "requestedExecutionDate" : "2016-05-16",
  "totalAmount" : {
    "amount" : 10.29,
    "currencyCode" : "USD"
  },
  "transferTransactionInformation" : {
    "counterpartyAccount" : {
      "arrangementId" : "7341696714117907699630",
      "externalArrangementId" : "7341696714117907600630",
      "identification" : {
        "identification" : "8a48e08c60daa5940160dac699050088",
        "schemeName" : "BBAN"
      }
    },
    "instructedAmount" : {
      "amount" : 10.29,
      "currencyCode" : "USD"
    }
  },
  "transactionInfo" : {
    "debitAmount" : 591.16,
    "commisionCalculation" : "N",
    "taxCalculation" : "Y",
    "taxData1" : 0,
    "taxData2" : 0,
    "totalAmount" : 10,
    "transCurAmt" : 20,
    "commisionAmt" : 10,
    "exchangeRate" : 57.45,
    "operationReferenceId" : "bc54531b-222b-4585-b392-f8e020868dc8"
  },
  "paymentDescription" : "Optional payment description",
  "contactInfo" : {
    "contactId" : "14b0b245-c7a9-427e-8e77-26c2f98dfa3d",
    "bankCode" : "ABHRDOS2XXX"
  },
  "creditCardPayment" : {
    "cardOwner" : "SAME_USER"
  },
  "deliveryChannel" : "BOL",
  "statusInfo" : {
    "status" : "error",
    "errorCode" : "M0005",
    "errorDescription" : "ERROR AL VALIDAR EL MFL",
    "errorInfo" : " ( NUMERO_CUENTA - 16 )-TAMAÑO BYTES TRAMA: ",
    "errorApi" : "PAYMENT_QUERY",
    "rqUID" : "2adf5bca-3640-4664-a961-ca47f8f7af2b",
    "bbErrorDescription" : "Field additions.deliveryChannel is not set and it is required for other banks payments."
  }
}
                },
    ]
}]);

export const PaymentsHttpServiceMocksProvider: Provider = createMocks(
    [
    {
        urlPattern: "/payment-order-aux-service/v2/payment",
        method: "POST",
        responses: [

//             {
//                 status: 200,
//                 body: {
//   "name" : "Consulta de impuestos de transacciones",
//   "tag" : 1,
//   "$ref" : "examples/body/paymentorderauxservice_response.json"
// }
//             },
            {
                status: 200,
                body: {
  "name" : "Consulta de impuestos de transacciones",
  "tag" : 1,
  "$ref" : "examples/body/paymentorderauxservice_response.json"
}
            },
            {
                status: 200,
                body: {
  "originatorAccount" : {
    "arrangementId" : "7341696714117907699630",
    "externalArrangementId" : "7341696714117907600630",
    "identification" : {
      "identification" : "8a48e08c60daa5940160dac699050088",
      "schemeName" : "BBAN"
    }
  },
  "paymentType" : "IN",
  "requestedExecutionDate" : "2016-05-16",
  "totalAmount" : {
    "amount" : 10.29,
    "currencyCode" : "USD"
  },
  "transferTransactionInformation" : {
    "counterpartyAccount" : {
      "arrangementId" : "7341696714117907699630",
      "externalArrangementId" : "7341696714117907600630",
      "identification" : {
        "identification" : "8a48e08c60daa5940160dac699050088",
        "schemeName" : "BBAN"
      }
    },
    "instructedAmount" : {
      "amount" : 10.29,
      "currencyCode" : "USD"
    }
  },
  "transactionInfo" : {
    "debitAmount" : 591.16,
    "commisionCalculation" : "N",
    "taxCalculation" : "Y",
    "taxData1" : 0,
    "taxData2" : 0,
    "totalAmount" : 10,
    "transCurAmt" : 20,
    "commisionAmt" : 10,
    "exchangeRate" : 57.45,
    "operationReferenceId" : "bc54531b-222b-4585-b392-f8e020868dc8"
  },
  "paymentDescription" : "Optional payment description",
  "contactInfo" : {
    "contactId" : "14b0b245-c7a9-427e-8e77-26c2f98dfa3d",
    "bankCode" : "ABHRDOS2XXX"
  },
  "creditCardPayment" : {
    "cardOwner" : "SAME_USER"
  },
  "deliveryChannel" : "BOL",
  "statusInfo" : {
    "status" : "error",
    "errorCode" : "M0005",
    "errorDescription" : "ERROR AL VALIDAR EL MFL",
    "errorInfo" : " ( NUMERO_CUENTA - 16 )-TAMAÑO BYTES TRAMA: ",
    "errorApi" : "PAYMENT_QUERY",
    "rqUID" : "2adf5bca-3640-4664-a961-ca47f8f7af2b",
    "bbErrorDescription" : "Field additions.deliveryChannel is not set and it is required for other banks payments."
  }
}
            },
    ]
},
]
);


